<label [for]="id" class="weight-medium is-uppercase"> {{ label }}</label>
<div class="field has-addons">
  <div class="control" *ngIf="!isGenericSelectAndFieldComponent" [formGroup]="form">
    <span class="select" [ngClass]="{
        'is-danger': getError()
      }">
      <select [formControlName]="inputNameType" [class.disabled-input]="disabled">
        <option *ngFor="let value of valuesSelect" [value]="value">
          {{ 'select-inputs.' + value | translate }}
        </option>
      </select>
    </span>
  </div>

  <div class="control w-100" [formGroup]="form" *ngIf="form?.controls?.searchType?.value === 'pnr'">
    <input class="input" type="text" [formControlName]="'pnr'" id="pnrInput" minlength="6" maxlength="6"
      autocomplete="off" [placeholder]="'dashboard.booking-search.pnr-placeholder' | translate"
      [class.disabled-input]="disabled" [class.is-uppercase]="true" [ngClass]="{
        'is-danger': getError()
      }" />
  </div>

  <div class="control has-icons-right w-100"
    *ngIf="form?.controls?.searchType?.value === 'tkt' || isGenericSelectAndFieldComponent">
    <input [(ngModel)]="inputValue" class="input" type="text" [disabled]="disabled" maxlength="13" minlength="13"
      id="addTicketsPNR" autocomplete="off" [placeholder]="
        isGenericSelectAndFieldComponent
          ? genericPlaceholder
          : ('dashboard.booking-search.tkt-placeholder' | translate)
      " [class.disabled-input]="disabled" [class.is-uppercase]="true" [ngClass]="{
        'is-danger': getError()
      }" (change)="ontktChange(inputValue)" />

    <span
      *ngIf="(inputValue?.length === 13 && form?.controls?.ticketNumbers?.controls?.length < 10) || isGenericSelectAndFieldComponent"
      class="icon is-small is-right has-text-grey has-events" (click)="addControl.emit(inputValue);
      inputValue = ''"
      [ngClass]="{
        'is-danger': getError()
      }">
      <div class="tooltipApp text-center" [textContent]="'dashboard.booking-search.addTKT' | translate"></div>
      <em class="mdi mdi-plus is-size-4 has-pointer-cursor "></em>
    </span>
  </div>
</div>

<p *ngIf="getError()" class="help is-danger">
  {{ errorMessage }}
</p>


<div [formGroup]="form" class="field is-grouped is-grouped-multiline" *ngIf="showTickets()">
  <div class="control" *ngFor="let tag of form?.controls?.ticketNumbers?.controls; let i = index">
    <div class="tags has-addons">
      <span class="tag is-link"> {{ tag.value }}</span>
      <a class="tag is-delete" (click)="deleteControl.emit(i)"></a>
    </div>
  </div>
</div>
